module.exports = "\n\n<app-login></app-login>\n\n"